import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import { MenuOutlined, Close, ArrowForward, Description } from "@mui/icons-material";
import "./Header.css";

const NAV_ITEMS = [
  { name: "Home", path: "/" },
  { name: "Committee", path: "/committee" },
  { name: "Scientific Program", path: "/event/e-miss-cvj-2026/scientific-program" },
  { name: "Accommodation", path: "/event/e-miss-cvj-2026/travel-and-accommodation" },
  { name: "Contact", path: "/contact" },
];

function ElevationScroll(props) {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return children ? (
    <AppBar elevation={trigger ? 4 : 0} position="fixed" className="app-bar">
      {children}
    </AppBar>
  ) : null;
}

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // close drawer on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const goTo = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const drawerContent = (
    <div className="drawer-container">
      {/* Drawer Header */}
      <div className="drawer-header">
        <div className="header-logo-container" onClick={() => goTo("/")}>
          <img src="/pgi.png" alt="logo" className="header-logo-img" />
          <img src="/neurosurgery.png" alt="logo" className="header-logo-img" />

          <div className="header-logo-text">
            <span className="header-logo-title">SGPGI</span>
            <span className="header-logo-subtitle">NEUROSURGERY</span>
          </div>
        </div>

        <Close className="close-icon" onClick={toggleDrawer} />
      </div>

      {/* Drawer Navigation */}
      <div className="drawer-nav-list">
        {NAV_ITEMS.map((item) => (
          <div
            key={item.name}
            className={`drawer-item ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => goTo(item.path)}>
            {item.name}
          </div>
        ))}
      </div>

      {/* Drawer Buttons */}
      <div className="drawer-buttons">
        <Link to="/registration" className="btn-register">
          Register Now
        </Link>
        {/* <Link to="/event/e-miss-cvj-2026/abstract" className="btn-register">
          <Description fontSize="small" /> Abstract Form
        </Link> */}
      </div>
    </div>
  );

  return (
    <>
      <ElevationScroll>
        <div className="top-header">
          <a href="/e-miss-cvj-2026.pdf" target="_blank" rel="noreferrer" className="brochure-btn">
            <Description fontSize="small" /> View Brochure
          </a>
        </div>
        <Toolbar className="toolbar-container">
          {/* Logo */}
          <Link to="/" className="header-logo-container">
            <img src="/pgi.png" alt="logo" className="header-logo-img" />
            <img src="/neurosurgery.png" alt="logo" className="header-logo-img" />

            <div className="header-logo-text">
              <span className="header-logo-title">SGPGI</span>
              <span className="header-logo-subtitle">NEUROSURGERY</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="desktop-nav">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? "active" : ""}`}>
                {item.name}
              </Link>
            ))}

            {/* <Link to="/registration" className="btn-register">
              Register Now
            </Link> */}

            {/* <Link to="/event/e-miss-cvj-2026/abstract" className="btn-register">
              <Description fontSize="small" /> Abstract Form
            </Link> */}
          </div>

          {/* Mobile Icon */}
          <div className="mobile-menu-icon" onClick={toggleDrawer}>
            <MenuOutlined fontSize="large" style={{ color: "var(--primary-blue)" }} />
          </div>
        </Toolbar>
      </ElevationScroll>

      {/* Drawer */}
      <Drawer anchor="right" open={mobileOpen} onClose={toggleDrawer} ModalProps={{ keepMounted: true }}>
        {drawerContent}
      </Drawer>
    </>
  );
};

export default Header;
